import {type UIMSceneEnum} from '../../../../../shared/enums/UIMSceneEnums.ts'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState.ts'
import {setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils.ts'
import {type UIMSceneController} from '../UIMSceneController.ts'
import {UIMProfileController} from './body/profile/UIMProfileController.ts'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts'

export class UIMProfileOverlayController {
    private readonly overlayContainer: HTMLDivElement
    private readonly backButton: HTMLImageElement
    private readonly sceneController: UIMSceneController

    private previousScene: UIMSceneEnum | undefined = undefined
    private profileController: UIMProfileController | undefined = undefined

    constructor(sceneController: UIMSceneController) {
        this.sceneController = sceneController
        this.overlayContainer = document.getElementById('profile-overlay-container') as HTMLDivElement
        this.backButton = document.getElementById('header-back-button') as HTMLImageElement

        setElementOnClick(this.backButton, () => this.hide())
        this.backButton.style.transition = ''
    }

    show() {
        if(!ClientUserState.userState?.isLoggedIn) {
            new ViewPopupLogin()
            return
        }

        this.previousScene = this.sceneController.scene
        this.sceneController.loadScene(undefined)
        this.overlayContainer.classList.remove('hidden')
        this.backButton.classList.add('visible')

        if(this.profileController == undefined) {
            const username = ClientUserState.userState?.username ?? ''
            this.profileController = new UIMProfileController(username)
        }
    }

    private hide() {
        const previousScene = this.previousScene
        this.hideAndClearPreviousScene()
        this.sceneController.loadScene(previousScene)
    }

    hideAndClearPreviousScene() {
        this.previousScene = undefined
        this.overlayContainer.classList.add('hidden')
        this.backButton.classList.remove('visible')
    }
}
